module.exports = __webpack_public_path__ + "static/media/logo.266ccb46.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo.svg
// module id = 28
// module chunks = 0